/**
 * SKŁADNIA createAsyncThunk:
 * https://redux-toolkit.js.org/api/createAsyncThunk
 */


import { createAsyncThunk } from '@reduxjs/toolkit'
import { SLICE_KEYS } from '../../SliceKeys'
import settingsService from 'service/SettingsService/SettingsService'
import analyticsService from 'service/AnalyticsService/AnalyticsService'

export const setGlobalConfigurationThunkAction = createAsyncThunk(
   `${SLICE_KEYS.GLOBAL_CONFIGURATION_SLICE}/setGlobalConfigurationThunkAction`,
   async(_, { rejectWithValue }) => {
      try {
         const globalConfig = (await settingsService.getGlobalConfig()).data
         return globalConfig
      } 
      catch (error: any) {
         try { //Gdy za pierwszym razem nie uda się pobrać konfiguracji, dla pewności próbujemy raz jeszcze.
            const globalConfig = (await settingsService.getGlobalConfig()).data
            return globalConfig
         } 
         catch (error: any) {
            return rejectWithValue({})
         }
      }  
   }
)

export const setAnalyticsEventTypesThunkAction = createAsyncThunk(
   `${SLICE_KEYS.GLOBAL_CONFIGURATION_SLICE}/setAnalyticsEventTypesThunkAction`,
   async(_, { rejectWithValue }) => {
      try {
         
         const analyticsEventTypes = analyticsService.getAnalyticsEventTypes()
         return analyticsEventTypes
      } 
      catch (error: any) {
         try { //Gdy za pierwszym razem nie uda się pobrać konfiguracji, dla pewności próbujemy raz jeszcze.
            const analyticsEventTypes = analyticsService.getAnalyticsEventTypes()
            return analyticsEventTypes
         } 
         catch (error: any) {
            return rejectWithValue({})
         }
      }  
   }
)